import React from 'react';
import {NextSeo} from 'next-seo';
import {StructuredData} from '@app/views/structuredData';
import {StrapiBlock} from './StrapiBlock';
import {getTranslationNamespaceForStrapiPage} from '../helpers';
import {useResolveTranslations} from '../hooks/useResolveTranslations';

type StrapiWrapperProps = {
	strapiData: any | null;
	contentType: string;
	translationNamespace?: string;
};

export const StrapiWrapper: React.FC<StrapiWrapperProps> = ({
	strapiData,
	contentType,
	translationNamespace: providedTranslationNamespace,
}) => {
	const translationNamespace = getTranslationNamespaceForStrapiPage(
		contentType,
		strapiData?.slug,
	);
	const resolvedTranslationNamespace =
		providedTranslationNamespace ?? translationNamespace;
	const resolve = useResolveTranslations(resolvedTranslationNamespace);
	const title =
		resolve(strapiData?.seo?.metaTitle) || resolve(strapiData?.title);
	const description = resolve(strapiData?.seo?.metaDescription);
	const metaImageSrc = strapiData?.seo?.metaImage?.src;
	return (
		<>
			<NextSeo
				title={title}
				description={description}
				noindex={strapiData?.seo?.noIndex}
				nofollow={strapiData?.seo?.noIndex}
				openGraph={
					description
						? {
								title,
								description,
								...(metaImageSrc && {
									images: [
										{
											url: metaImageSrc,
											width: strapiData?.seo?.metaImage?.width,
											height: strapiData?.seo?.metaImage?.height,
											alt: resolve(strapiData?.seo?.metaImage?.alt),
										},
									],
								}),
							}
						: undefined
				}
			/>
			<StructuredData
				description={description}
				withBreadCrumbStructuredData={undefined}
			/>
			{strapiData?.blocks?.map((block: any) => (
				<StrapiBlock
					key={`${block.__component}-${block.id}`}
					strapiBlockData={block}
					contentType={contentType}
					translationNamespace={resolvedTranslationNamespace}
				/>
			))}
		</>
	);
};
